import { selector } from 'recoil';
import { httpGet } from 'modules/api';

export const filterOptionsSelector = selector({
    key: 'FilterOptions',
    get: async () => {
        try {
            return httpGet('/maps/filter-options');
        } catch {
            return { sortOptions: [], tagOptions: [], colorOptions: [] };
        }
    },
});
